/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import AnalyticsUtil from '../../utils/AnalyticsUtil';
import RedirectionUtils from '../../utils/RedirectionUtils';

class EntitlementService {
	isUserEligible: boolean;
	initialized: boolean;
	// Singleton
	static instance: EntitlementService;

	constructor() {
		if (!EntitlementService.instance) {
			this.isUserEligible = false;
			this.initialized = false;
			EntitlementService.instance = this;
		}
		return EntitlementService.instance;
	}

	isUserEligibleForCCHome(language) {
		let test = false;
		if (window.adobeIMS && window.adobeIMS.getUserProfile()) {
			test = this.initialized ? this.isUserEligible : this._isEligibleForCCHome(language);
		} else {
			this.isUserEligible = false;
		}
		return test;
	}

	/**
	 *
	 * This method checks to see if this user is eligible for CC Home.
	 * @param {string} language The current client language code for CC Home.
	 */
	_isEligibleForCCHome(language) {
		const clientLanguage = language ? language : 'en';
		let isEligible = true;

		// All users except for those whose IMS country code is set to China are eligible for CC Home.
		const imsProfile = window.adobeIMS.getUserProfile();
		if (imsProfile && imsProfile.countryCode && imsProfile.countryCode.toLowerCase() === 'cn') {
			isEligible = false;
		}
		this.isUserEligible = isEligible;

		const analytics = new AnalyticsUtil();
		analytics.postEligibilityAnalytics(
			this.isUserEligible,
			RedirectionUtils.getAdobeRedirectURL(window.location.href, clientLanguage),
		);

		this.initialized = true;
		return this.isUserEligible;
	}
}

export default EntitlementService;
